import {
  ChangeDetectionStrategy,
  Component,
  model,
  signal,
} from '@angular/core';
import { InventoryTemplateComponent } from '@core/components/inventory-template/inventory-template.component';
import { Skin } from '@core/interfaces/skin.interface';
import { KingType } from '@features/king/types/king.type';
import { ModalService } from '@features/modals/services/modal.service';
import { JackpotHrService } from '@old-app/jackpot/jackpot-hr.service';

@Component({
  selector: 'app-deposit-jackpot-modal',
  imports: [InventoryTemplateComponent],
  templateUrl: './deposit-jackpot-modal.component.html',
  styleUrl: './deposit-jackpot-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DepositJackpotModalComponent {
  readonly type = signal<KingType>('vault');
  readonly selectedSkins = model<Skin[]>([]);
  readonly isProcessing = signal(false);

  constructor(
    private jackpotService: JackpotHrService,
    private modalService: ModalService
  ) {}

  public async joinJackpot() {
    this.isProcessing.set(true);
    try {
      const trade = await this.jackpotService.joinJackpot(this.selectedSkins());

      this.modalService.openModal('TradeModal', {
        tradeModalOptions: {
          trade_offer_id: trade.offerid,
          trade_hash: trade.hash,
          trade_skins: this.selectedSkins(),
          typography_trade_for: 'join the jackpot',
        },
        balance: 'skins',
      });

      this.modalService.closeModals(['DepositJackpotModal']);
    } catch {
    } finally {
      this.isProcessing.set(false);
    }
  }

  toggleType() {
    this.type.update((type) => (type === 'fight' ? 'vault' : 'fight'));
  }
}
